import { Badge } from '@/components/ui/badge'

// Selos das tags de uma transação (nomes vindos da coluna text[]).
export function TagBadges({ tags }: { tags?: string[] | null }) {
  if (!tags || tags.length === 0) return null
  return (
    <>
      {tags.map((t) => (
        <Badge key={t} variant="secondary" className="text-primary ml-1 align-middle text-[10px] font-normal">
          {t}
        </Badge>
      ))}
    </>
  )
}
